import shareModal from '@/entities/insights/modal/share/share-modal.vue';
import ScrapboardManagerService from '@/entities/new-learning-center/scrapboard-manager.service';
import { getHostName, handleDateTimeCardFeed } from '@/util/ds-util';
import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import { generateBody, generateReference, groupByComponentName } from '../report-common';
import axios from 'axios';
@Component({
  name: 'single-report',
  components: {
    'report-share': shareModal,
  },
})
export default class singleReport extends Vue {
  @Inject('scrapboardManagerService') private scrapboardManagerService: () => ScrapboardManagerService;

  [x: string]: any;
  @Prop(Boolean) readonly isList: boolean | undefined;
  @Prop() readonly report: any | undefined;
  @Prop(Boolean) readonly isEdit: boolean | undefined;
  @Prop() readonly lstSelectedDoc: any;

  internalSelectedItems = [];

  handleSelectReport(report: any) {
    const findIndex = this.internalSelectedItems.findIndex(i => i.docId == report.docId);
    if (findIndex == -1) {
      this.internalSelectedItems.push(report);
    } else {
      this.internalSelectedItems.splice(findIndex, 1);
    }
    this.$emit('setSelectedItems', this.internalSelectedItems);
  }

  @Watch('lstSelectedDoc')
  lstSelectedDocChage() {
    this.internalSelectedItems = this.lstSelectedDoc;
  }

  mounted() {}

  handleShare() {
    this.$root.$emit('setDetailReportModal', this.report);
  }

  processDatetime(datetime) {
    return handleDateTimeCardFeed(datetime, this);
  }

  imgSource() {
    console.log('this.report', this.report);
    if (this.report?.images || this.report?.ogImageUrl || (this.report?.image_url && this.report?.image_url[0]))
      return this.report?.images || this.report?.ogImageUrl || (this.report?.image_url && this.report?.image_url[0]);
    else return 'content/images/thumbnail-empy-t02.png';
  }

  onErrorImage(e) {
    e.target.src = 'content/images/thumbnail-empy-t02.png';
  }

  ExtractHostname(url, writer) {
    const name = getHostName(url);
    if (name) return name;
    return writer;
  }

  saveScrap() {
    if (!this.report.is_scrap) {
      axios
        .get(`/api/insights/report`, {
          params: {
            reportId: this.report.id,
          },
        })
        .then(async res => {
          if (res?.status === 200 && res?.data) {
            const detailReport = res?.data;
            const localStorageUser = JSON.parse(localStorage.getItem('localStorageUser'));
            const connectomeId = localStorageUser?.connectomeId;
            const newObj = groupByComponentName(detailReport.components);
            const content = generateBody(newObj?.body_component || []);
            const reference = generateReference(newObj?.Reference?.elements || []);

            let html = '';
            if (content.html.length > 0) {
              content.html.forEach(item => {
                html += `<div>${item}</div>`;
              });
            }

            const objRequest = {
              requestedScrapList: [],
              requestId: new Date().getTime(),
              title: this.report.title,
              forcedClustering: false,
              targetScrapboardId: this.report.scrapboardId,
              path: `${location.protocol}//${location.host}/detail-report/${this.report.id}`,
              content: content.content,
              type: 'REPORT',
              connectomeId: connectomeId,
              author: 'https://goover.ai',
              description: this.report.description,
              searchType: 'WEB',
              favicon: 'https://goover.ai/favicon.ico',
              lang: this.report.language,
              keyword: '',
              originDate: this.report.created_at,
              img: this.report.img,
              html_content: `${html}<div>${reference.html}</div>`,
            };
            this.scrapboardManagerService()
              .saveScrap([objRequest])
              .then(res => {
                if (res?.status === 200 && res?.data?.body?.result_code === 0) {
                  this.customToast(this.$t('report.saveScrapSuccess'), this.$t('report.success'), 'success');
                  this.$emit('updateIscrapReport', this.report.id);
                } else this.customToast(this.$t('report.saveScrapError'), this.$t('report.error'), 'danger');
              })
              .catch(err => {
                this.customToast(this.$t('report.saveScrapError'), this.$t('report.error'), 'danger');
                console.log('err', err);
              });
          }
        })
        .catch(err => {
          console.log('err', err);
          this.customToast(this.$t('report.saveScrapError'), this.$t('report.error'), 'danger');
        });
    }
  }

  gotoDetail() {
    this.$emit('gotoDetail', this.report);
  }

  customToast(message, title, variant) {
    this.$bvToast.toast(message, {
      toaster: 'b-toaster-bottom-right',
      title: title,
      variant: variant,
      solid: true,
      autoHideDelay: 4000,
    });
  }

  navigateToDetail() {
    this.$router.push({ name: 'Detail-report', params: { reportId: this.report.id } });
  }
}
